import React, { useEffect, useState,useRef,useCallback } from 'react';
import { connect } from 'react-redux';
import Button from 'jd-library/Button';
import config from '../../../config/config';
import SliderHeader from 'jd-library/SliderHeader';
import {useHistory, useParams, useLocation} from 'react-router-dom';
import {setLoggedUser} from '../../actions/index';
import {logOut, auditSearch, rewriteUrlForLocal} from '../../utills';
import FormDate from 'jd-library/FormDate';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import ContractSearchPage from './ContractSearchPage';
import axios from 'axios';
import queryString from 'query-string';
import {setAuditObject} from '../../actions/products';
import './home.scss';
import { showToastMessage } from '../../actions/toastmessage';
import SliderWrapper from "jd-library/SliderWrapper";
import Modal from "jd-library/Modal";
import {serverHost} from '../../../config/config'; 
import ImageIcons from 'jd-library/ImageIcons';
import Dropdown from 'jd-library/Dropdown';

import {AuditButton} from "./AuditButton";
import {AuditStats} from './AuditStats';

const searchByArr = [
//     {
//     key: 'citycircle',
//     display: 'City Circle'
// },
{
    key: 'docId',
    display: 'Doc ID'
},
{
    key: 'productId',
    display: 'Product ID'
},
// {
//     key: 'employee',
//     display: 'Employee'
// }
];

const searchTypeArr = [{
    key: 'contracts',
    display: 'Contracts'
},{
    key: 'products',
    display: 'Products'
}];

const employeeTabList = [{
    key: 'employeeid',
    display: 'Employee ID'
},{
    key: 'employeemobile',
    display: 'Employee Mobile No.'
}];

const closeObj = {
    timeout:null
}
let loader;

const getCityList = (options = {}) => {
    let {updateCityList,updateSelectedCity} = options;
    axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=getDatacityList`).then((data) => {
        if(data.data.status) {
            let list = data.data.data;
            list = list.map((item) => {
                return (
                    <option 
                        value={item}
                        key = {item}
                    >
                        {item}
                    </option>
                )
            });
            list.unshift(<option 
                value='Select City'
                selected 
                key='Select City'
            >
              {'Select City'}
            </option>);
            updateCityList(list);
            updateSelectedCity('Select City');
        }
    });
};

const downloadReports = (options = {}) => {
    let {type} = options;
    let url = `${window.location.origin}`;
    if(type == 'auditReport') {
        url += '/marketplace/static/php/report/allreport.php?case=getPregeneratedFiles&export=yes&file=b2b_audi_report_phase1';
    } else {
        url += '/marketplace/static/php/report/allreport.php?case=getPregeneratedFiles&export=yes&file=b2bSkippedFurloagContract';
    }
    window.open(url, "_blank");
};

const formatDate = (date) => {
    date = date.split("/");
    date = `${date[2]}-${date[1]}-${date[0]}`;
    return date;
};

const getDateString = (date) => {
    let dateStr = date.toISOString();
    dateStr = dateStr.split("T")[0];
    dateStr = dateStr.split("-");
    dateStr = `${dateStr[2]}/${dateStr[1]}/${dateStr[0]}`;
    return dateStr;
};

const downloadDateWiseReport = (options = {}) => {
    let {startDate='', endDate='', showToastMsg} = options;
    const domain = `https://${serverHost}`;
    startDate = formatDate(startDate);
    endDate = formatDate(endDate);
    axios.get(`/marketplace/static/php/report/b2bAuditReportExport.php?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`).then(({data}) => {
        if(data.isSuccess) {
            //let filePath = `${domain}/downloads/b2bAuditReport/${data.file}`;
            options.cb && options.cb("pass",data.file);
        }else if(data.isSuccess == -1){
            options.cb && options.cb("failed");
        }else {
            options.cb && options.cb("failed");
            showToastMsg && showToastMsg("No Data Found for Selected Date Range");
        }
    });
};

const furloughApi = (options = {}) => {
    let {updateFurDocIdError, 
        updateFurBtnLoader, 
        furDocId, 
        toggleModal, 
        isCheck,
        furBtnLoader, 
        updateSlider,
        showToastMsg,
        updateConfirmBtnLoader,
        updateFurModalData,
        confirmBtnLoader} = options;
    if(!furDocId) {
        const msg = 'Please Enter Valid Doc ID';
        updateFurDocIdError(msg);
        showToastMsg(msg);
        return;
    }
    const url = `/marketplace/static/php/web/b2bWebsite.php?action=removeDocidFromSkippedQueue&skippedDocid=${encodeURIComponent(furDocId)}&removeFromSkip=${isCheck ? 0 : 1}`;
    if(isCheck) {
        if(furBtnLoader) {
            return;
        }
        updateFurBtnLoader(true);
        axios.get(url).then((data) => {
            data = data.data;
            if(data.status) {
                toggleModal(true);
                let userData = data.userData || {};
                updateFurModalData(userData);
            } else {
                updateFurDocIdError(data.msg);
                showToastMsg(data.msg);
            }
            updateFurBtnLoader(false);
        });
    } else {
        if(confirmBtnLoader) {
            return;
        }
        updateConfirmBtnLoader(true);
        axios.get(url).then((data) => {
            data = data.data;
            if(data.status) {
                updateConfirmBtnLoader(false);
                updateSlider('');
                updateFurModalData({});
                showToastMsg('Contract Converted to Furlough');
                window.history.go(-2);
            }
        });
    }
};

const HomePage = props => {
    const [isCorrector, updateIsCorrector] = useState(false);
	const [furModalData, updateFurModalData] = useState({});
    const [showModal, toggleModal] = useState(false);
    const [searchBtnLoader, updateSearchBtnLoader] = useState(false);
    const [confirmBtnLoader, updateConfirmBtnLoader] = useState(false);
    const [furBtnLoader, updateFurBtnLoader] = useState(false);
    const [searchByVal, updateSearchByVal] = useState('docId');
    const [selectedCity, updateSelectedCity] = useState('Select City');
    const [employeeTab, updateEmployeeTab] = useState('employeeid');
    const [docId, updateDocId] = useState('');
    const [furDocId, updateFurDocId] = useState('');
    const [productId, updateProductId] = useState('');
    const [docIdError, updateDocIdError] = useState('');
    const [furDocIdError, updateFurDocIdError] = useState('');
    const [empId, updateEmpId] = useState('');
    const [empMobileNo, updateEmpMobileNo] = useState('');
    const [productIdError, updateProductIdError] = useState('');
    const [empInputError, updateEmpInputError] = useState('');
    const [showResultVal, updateShowResultVal] = useState('contracts');
    const [cityError, updatecityError] = useState(false);
    let date = new Date();
    date.setHours(0,0,0,0);
    const [fromDate, updateFromDate] = useState('');
    const [toDate, updateToDate] = useState('');
    const [cityOptions, updateCityList] = useState([]);
    const [dateError1, updateDateError1] = useState('');
    const [dateError2, updateDateError2] = useState('');
    const [showSlider, updateSlider] = useState('');
    const [exportDataSlider, setExportDataSlider] = useState(false)
    const [auditExpValue, setAuditExpValue] = useState({})
    const [auditExpDropDown, setAuditExpDropDown] = useState(true)
    const [auditExpEmailToggle, setAuditExpEmailToggle] = useState(false)
    const [auditExpEmail, setAuditExpEmail] = useState('')
    const [auditExpEmailArr, setAuditExpEmailArr] = useState([])
    const [auditExpEmailErr, setAuditExpEmailErr] = useState(false)
    const [notValidEmail, setNotValidEmail] = useState('')
    const [auditExpCurrentStep, setAuditExpCurrentStep] = useState(0)
    const [currentStep, updateCurrentStep] = useState(0);
    const [progressVal,updateVal] = useState(0);
    const [auditReportStatus,updateAuditReportStatus] = useState("pass");
    const [reportAuditLink,updateReportAuditLink] = useState('');
    const [reportAuditLoader,updateReportAuditLoader] = useState(false);
    const circleRef = useRef(null);

    const [auditStats,updateAuditStats] = useState({
        lastUpdated: '',
        nonrelevanceQueueCount:0,
        nonrelevanceQueueDocIdCount:0,
        nonrelevanceServiceQueueCount:0,
        nonrelevanceServiceQueueDocIdCount:0,
        onboardEmpQueueCount:0,
        onboardEmpServiceQueueCount: 0,
        onboardEmpQueueDocIdCount:0,
        contractorCount:0,
        contractorServiceCount: 0,
        contractorDocIdCount:0,
        contractorV2Count:0,
        contractorV2ServiceCount: 0,
        contractorV2DocIdCount:0,
        objectionablePaidCount:0,
        objectionableDocIdPaidCount:0,
        objectionableFreeCount:0,
        objectionableDocIdFreeCount:0,
        paidObjectionalServiceCount:0,
        paidObjectionalServiceDocIdCount:0,
        nonpaidObjectionalServiceCount:0,
        nonpaidObjectionalServiceDocIdCount:0,
        correctorQueueCount: 0
        /*
        regularCount: '',
        furloughCount: '',
        nonrelevanceQueueCount:0,
        nonrelevanceServiceQueueCount:0,
        regularDocIdCount:0,
        furloughDocIdCount:0,
        onboardQueueCount:0,
        onboardQueueDocIdCount:0,
        objectionablePaidDocIdCount:0,
        objectionableFreeDocIdCount:0,
        regularBrandCount:0,
        regularBrandDocIdCount:0,
        customSellonlineCount:0,
        customSellonlineDocIdCount:0,
        regularBrandCqueueCount: 0,
        regularBrandCqueueDocIdCount: 0,
        regularBrandMrpCount: 0,
        regularBrandMrpDocIdCount:0,
        nonpaidRegularServiceCount:0,
        paidRegularServiceCount:0,
        nonpaidRestrictedServiceCount:0,
        paidRestrictedServiceCount:0,
        */        
    });
    
    const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
	);
    const handleScroll = useCallback(() => {
		let isScrolled = document.scrollingElement.scrollTop > 0 ? true : false; 
		setScroll(isScrolled);
	}, []);

    useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

    
    let sliderObject, startDate = new Date();
    startDate.setDate(startDate.getDate() - 1);
    const [reportObj, updateReportobj] = useState({
        startDate: startDate,
        endDate: startDate,
        startError: '',
        endError: '',
        startDateStr: getDateString(startDate),
        endDateStr: getDateString(startDate)
    });
    let val = progressVal;
    
    let auditExpArr = [
        {
            label: 'Owner LTBM Product Audit Queue',
            key: 'OWNER_NONRELEVANCE'
        },{
            label: 'Owner LTBM Service Audit Queue',
            key: 'OWNER_NONRELEVANCE_SERVICE'
        },{
            label: 'Onboarding LTBM Product Audit Queue',
            key: 'ONBOARDEMP',
        },{
            label: 'Onboarding LTBM Service Audit Queue',
            key: 'ONBOARDEMP_SERVICE',
        },{
            label: 'Contractor v1 LTBM Product Audit Queue',
            key: 'CONTRACTOR',
        },{
            label: 'Contractor v1 LTBM Service Audit Queue',
            key: 'CONTRACTOR_SERVICE',
        },{
            label: 'Contractor v2 LTBM Product Audit Queue',
            key: 'CONTRACTORV2',
        },{
            label: 'Contractor v2 LTBM Service Audit Queue',
            key: 'CONTRACTORV2_SERVICE',
        },{
            label: 'Paid Objectionable Product Audit Queue',
            key: 'OBJ_PAID_PRODUCT_AUDIT',
        },{
            label: 'Non-paid Objectionable Product Audit Queue',
            key: 'OBJ_NON_PAID_PRODUCT_AUDIT',
        },{
            label: 'Paid Objectionable Service Audit Queue',
            key: 'OBJ_PAID_SERVICE_AUDIT',
        },{
            label: 'Non-paid Objectionable Service Audit Queue',
            key: 'OBJ_NON_PAID_SERVICE_AUDIT'
        }
        /*
        {
            label: 'Paid Regular Service Queue',
            key: 'PAID_REG_SERVICE',
        },
        {
            label: 'Non-Paid Regular Service Queue',
            key: 'NON_PAID_REG_SERVICE',
        },
        {
            label: 'Branded Cqueue Audit Queue',
            key: 'JDEMPLOYEE_BRANDED',
        },
        {
            label: 'Paid Restricted Service Category Queue',
            key: 'PAID_RESTR_SERVICE',
        },
        {
            label: 'Non-Paid Restricted Service Category Queue',
            key: 'NON_PAID_RESTR_SERVICE',
        },
        */
    ]

    const exportDataSliderHandler = () => {
        if (exportDataSlider && auditExpDropDown) {
            setAuditExpValue({})
            setExportDataSlider(false)
        } else if (exportDataSlider && auditExpEmailToggle) {
            setAuditExpEmailErr(false)
            setNotValidEmail('')
            setAuditExpCurrentStep(0);
            setAuditExpDropDown(true)
            setNotValidEmail('')
            setAuditExpEmail('')
            setAuditExpEmailToggle(!auditExpEmailToggle)
        }

    }

    const exportEmailHandler = (e) => {
        if (e == ',') {
            let softEmail = [...auditExpEmailArr];
            softEmail.push(e.target.value)
            setAuditExpEmailArr(softEmail)
        } else {
            setAuditExpEmail(e);
        }
    }
    const jdEmailValidator = () => {
        const emails = auditExpEmail.split(',')
        const arr = emails.filter(function(entry) { return /\S/.test(entry); });
        const emailResults = arr.map(element => {
          return element.trim();
        });
        for (let i = 0; i < emailResults.length; i++) {
            if (/@justdial.com\s*$/.test(emailResults[i])) {
                setAuditExpEmailErr(false)
                setNotValidEmail('')
                if ([i] == emailResults.length - 1) {
                    auditExpData()
                }
            } else {
                setAuditExpEmailErr(true)
                setNotValidEmail(emailResults[i])
                break;
            }
        }
    }

    const exportQueueDataHandler = () => {
        auditExpValue.key && setAuditExpDropDown(false)
        auditExpValue.key && setAuditExpEmailToggle(true)
        auditExpEmail && jdEmailValidator();
        auditExpValue.key && setAuditExpCurrentStep(1)
        auditExpCurrentStep == 0 && !auditExpValue.key &&  showToastMsg('Please select Queue')
        if (auditExpValue.key && !auditExpEmail && auditExpCurrentStep){
            setAuditExpEmailErr(true)
        }  
    }

    const auditExpData = () => {
        axios.post(`/marketplace/static/php/web/moduleApi.php?action=sendAuditorData&auditorAction=${auditExpValue.key}&queueName=${auditExpValue.label}`,null , {headers: {'userEmail': auditExpEmail}}).then((data)=>{
            if (data.data.successCode == 1){
                const emails = auditExpEmail.split(',')
                showToastMsg(`${auditExpValue.label} Data will be sent to entered Email ${emails.length > 1 ? 'addresses' : 'address'} `);
                setAuditExpEmailToggle(false)
                setAuditExpCurrentStep(0);
                setAuditExpEmailErr(false);
                setAuditExpEmail('');
                setAuditExpDropDown(true);
                setAuditExpValue('');
                setExportDataSlider(false);
            }else if(data.data.errorCode == 1) {
                console.log('errMsg',data.data.msg);
            }
        })

    }


    const getData = (options = {}) => {
		axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=checkAuditReportStatus`).then(({data})=>{
            if(data.status){
                if(data.progressCnt == 100){
                    val = 100;
                    updateCurrentStep(2);
                }else{
                   val = Math.floor(data.progressCnt);
                   //val+=5;
                }
                loader && loader();
            }
            options.cb && options.cb(data);
        })
    };

    const resetAuditReportSlider = () =>{
        updateCurrentStep(0);
        updateVal(0);
        updateAuditReportStatus("pass");
        updateReportAuditLink('');
        updateReportAuditLoader(false);
    }

    useEffect(() => {
        if(currentStep == 1){
            loader = () => {
                if(closeObj.timeout){
                    clearTimeout(closeObj.timeout);
                }
                closeObj.timeout = setTimeout(()=>{
                    if(val >= 100){
                        circleRef && circleRef.current && (circleRef.current.style.strokeDashoffset = 0);
                        updateVal(val);
                        updateCurrentStep(2);
                    }
                    else{
                        var r = 38;
                        var c = Math.PI*(r*2);
                        if (val < 0) { val = 0;}
                        if (val > 100) { val = 100;}
                        var pct = ((100-val)/100)*c;
                        updateVal(val);
                        circleRef && circleRef.current && (circleRef.current.style.strokeDashoffset = pct);
                        //val+=5;
                        getData();
                    }
                },1000)
            }
            getData();
        }
    },[currentStep])
    let furloughInput = {
        value: furDocId ,
        autoFocus: false,
        type: 'text',
        onChange: e => {
            updateFurDocId(e.target.value);
            updateFurDocIdError('');
        }
    };
    

    let furloughInputGroup = {rightSection:(() => {return(<div onClick={pasteFromClipboard} className = {'doc-paste-field'}>Paste</div>)}),
        rightIconClass : (furDocId ? 'icon-HDRcross' : ''),
        onRightIconClick:()=>{
            updateFurDocId('');
            updateFurDocIdError('');
        }
    }
    
    if(showSlider == 'audit-report') {
        const onStartChange = (event, obj, date) => {
            let prevState = {...reportObj};
            if(obj > reportObj.endDate) {
                prevState.startError = "Please Select Valid Date Range";
            } else if(Math.abs(reportObj.endDate - obj) > 2678400000) {
                prevState.startError = "Maximum Range Cannot Exceed Beyond 31 Days";
            } else {
                prevState.endError = "";
                prevState.startError = "";
            }
            prevState.startDate = obj;
            prevState.startDateStr = date;
            updateReportobj(prevState);
        }
        const onEndChange = (event, obj, date) => {
            let prevState = {...reportObj};
            if(obj < reportObj.startDate) {
                prevState.endError = "Please Select Valid Date Range";
            } else if(Math.abs(obj - reportObj.startDate) > 2678400000) {
                prevState.endError = "Maximum Range Cannot Exceed Beyond 31 Days";
            } else {
                prevState.endError = "";
                prevState.startError = "";
            }
            prevState.endDate = obj;
            prevState.endDateStr = date;
            updateReportobj(prevState);
        }

        let auditReportHtm = (
            <div className = {`date-holder`}>
                <div className = {'date-label'}>{`Select Date Range`}</div>
                <div className = {'date-input'}>
                    <FormDate label = {'Start Date'} dateformat={'dd/mm/yyyy'} errorMessage={reportObj.startError} startDate={reportObj.startDate} isMobile={true} onDateChange={onStartChange} iconClass='icon-Calendar' />
                </div>
                <div className = {'date-input'}>
                    <FormDate label = {'End Date'} dateformat={'dd/mm/yyyy'} errorMessage={reportObj.endError} startDate={reportObj.endDate} isMobile={true} onDateChange={onEndChange} iconClass='icon-Calendar' />
                </div>
            </div>
        );
        if(currentStep == 1){
            auditReportHtm = (<div className={'catalogue-holder'}>
                <div className={'catalogue-loader'}>
                    <div className={'cont'} id="cont" data-pct="100">
                        <svg  className={'svg'} id="svg" width="5rem" height="5rem" viewPort="0 0 2.5rem 2.5rem" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <circle  className={'circle'} r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset="0"></circle>
                        <circle  className={'circle'+' '+ 'bar'} ref = {circleRef} id="bar" r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset={((100 - progressVal)/100) * 239}></circle>
                        </svg>
                        <div className={'catalogue-percentage'}>{progressVal}%</div>
                    </div>
                </div>
                <div className={'catalogue-text'}>
                    {"Audit Report Export in Progress"}
                </div>
                <div className={'catalogue-subtext'}>
                    {"Please wait till it gets exported"}
                </div>
            </div>)
        }else if(currentStep == 2){
            auditReportHtm = (
                <div className={'report-result-holder'}>
                    <div className={'report-result-image'}>
                    {(auditReportStatus == "pass") ? <img className={'img'} src = {ImageIcons.CHECK_MARK_GIF} /> : <span className = {"icon-alert_outline2"}></span>}
                    </div>
                    <div className={'report-result-text'}>
                        {(auditReportStatus == "pass") ? "Audit Report Exported Successfully" : "Audit Report Export Failed"}
                    </div>
                    <div className={'report-result-button-holder'}>
                    <Button
                            showLoader = {reportAuditLoader}
                            size="lg"
                            className= "report-result-button"
                            clickHandler = {() => {
                                updateReportAuditLoader(true);
                                if(auditReportStatus == "pass" && reportAuditLink){
                                    window.open(reportAuditLink, "_blank");
                                }else{
                                    resetAuditReportSlider();
                                }
                                updateReportAuditLoader(false);
                            }}
                            block
                        >
                        {(auditReportStatus == "pass") ? "Download File" : "Try Exporting Again"}
                        </Button>
                    </div>
            </div>
            )
        }

        sliderObject = {
            header: {
                heading: 'Audit Report',
                variant: 'white',
                leftIcons: [{
                    className: "icon-hdrBackNew",
                    onClick: () => {
                        if(currentStep == 2){
                            resetAuditReportSlider();
                        }else{
                            window.history.back();
                        }
                    }
                }]
            },
            footer: {
                btnProps: (currentStep == 0) ? [{
                    children: 'Continue',
                    onClick: () => {
                        if(!reportObj.startError && !reportObj.endError) {
                            updateCurrentStep(1);
                            downloadDateWiseReport({
                                startDate: reportObj.startDateStr,
                                endDate: reportObj.endDateStr,
                                showToastMsg,
                                cb : (status,link) => {
                                    if(status == "pass"){
                                        updateReportAuditLink(link);
                                        updateAuditReportStatus(status);
                                    }else{
                                        updateAuditReportStatus(status);
                                    }
                                    updateCurrentStep(2);
                                }
                            });
                        }
                    }
                }] : []
            },
            slider: {
                width: "100%"
            },
            onHidden: () => {
                updateSlider('');
                clearInterval(closeObj.timeout);
                resetAuditReportSlider();
                updateReportobj({
                    startDate: startDate,
                    endDate: startDate,
                    startError: '',
                    endError: '',
                    startDateStr: getDateString(startDate),
                    endDateStr: getDateString(startDate)
                });
            },

            html: <div className = {`audit-download-reports`}>
                    <div className={`progress-status`}>
                            <div className={`progress-circle ${currentStep > 1 ? 'completed':''} ${currentStep == 0 ? 'current':''}`}>
                                {currentStep > 0 ? <i className='icon-Checkmark'></i>: null}
                            </div>
                            <div className={`progress-circle-connect ${currentStep > 0 ? 'filled':''}`}></div>
                            <div className={`progress-circle ${currentStep > 1 ? 'completed':''} ${currentStep == 1 ? 'current':''}`}>
                                {currentStep > 1? <i className='icon-Checkmark'></i>: null}
                            </div>
                    </div>
                    {auditReportHtm}
            </div>
        };
    } else {
        sliderObject = {
            header: {
                heading: 'Convert Contract to Furlough',
                headingClass: 'audit-heading',
                className: 'convert-header',
                variant:"white",
                leftIcons: [{
                    className: "icon-hdrBackNew",
                    onClick: () => {
                        window.history.back();
                    }
                }]
            },
            slider: {
                width: "100%"
            },
            onHidden: () => {
                updateSlider('');    
            },
            html: <div className = {'furlough-section'}>
                    <div className = {'section'}>
                        <InputWithMovingLabel
                                label={'Enter Doc ID'}
                                ref = {furloughRef}
                                holderClass={''}
                                input={furloughInput}
                                key={'docIDFur'}
                                inputGroupProps = {furloughInputGroup}
                                errorMessage = {furDocIdError}
                        />
                    </div>
                    <Button
                        showLoader = {furBtnLoader}
                        className= "convert-submitBtn"
                        size="lg"
                        clickHandler = {() => {
                            if(showModal) {
                                return;
                            }
                            furloughApi({
                                updateFurDocIdError,
                                updateFurBtnLoader,
                                furDocId,
                                toggleModal,
                                updateSlider,
                                furBtnLoader,
                                isCheck: true,
                                showToastMsg,
                                confirmBtnLoader,
                                updateFurModalData,
                                updateConfirmBtnLoader
                            });
                        }}
                        block
                    >
                        Submit
                    </Button>
                </div>
        };
    }
	let pasteRef = useRef(null);
    let furloughRef = useRef(null);
    let inputRef = useRef(null);

    let productIdPaste = (event, isPaste = false) => {
        if (isPaste) {
            const paste = (event.clipboardData || window.clipboardData).getData('text');
            if (/[eE\+\-\.]/.test(paste)) {
                event.preventDefault();
            }
        } else {
            if (isNaN(event.target.value) || ["e", "E", "+", "-", "."].includes(event.key)) {
                event.preventDefault();
            }
        }
    }
    const docProdKeyDown = (e) => {
        if (e.key == 'Enter'){
            onSearch()
        }
        searchByVal == 'docId' ? null : productIdPaste
    }

    const resetError = () =>{
        updateDocIdError('');
        updateProductIdError('');
        updateEmpInputError('');
        updatecityError('');
        updateDateError1('');
        updateDateError2('');
        updateDocId('');
        updateProductId('');
        updateEmpId('');
        updateEmpMobileNo('');
        updateSelectedCity('Select City');
    }
    let docIdInput = {
        value: searchByVal == 'docId' ? docId : productId,
        autoFocus: false,
        type: searchByVal == 'docId' ? 'text' : 'number',
        onKeyDown: e => docProdKeyDown(e),
        onPaste: searchByVal == 'docId' ? null : event => productIdPaste(event, true),
        onChange: e => {
            if (searchByVal == 'docId') {
                updateDocIdError('');
                updateDocId(e.target.value);
            } else {
                updateProductIdError('');
                updateProductId(e.target.value);
            }
        },
        className: 'doc-id-input'
    }

    
    let empIdInput = {
        value: employeeTab == 'employeeid' ? empId : empMobileNo ,
        autoFocus: false,
        type: employeeTab == 'employeeid' ? 'text': 'number',
        onChange: e => {
            updateEmpInputError('');
            if(employeeTab == 'employeeid') {
                updateEmpId(e.target.value);
            } else {
                updateEmpMobileNo(e.target.value);
            }
        }
    }
    const params = useParams();
    let history = useHistory();
    const isSamsungBrowser = navigator?.userAgent?.toLowerCase()?.includes('samsung');
    const pasteFromClipboard = () =>{
        if(!navigator.clipboard) {
            return null;
        }
        navigator.clipboard.readText().then(text => {
            if(text) {
                text = text.trim();
                if(showSlider) {
                    updateFurDocId(text);
                    updateFurDocIdError('');
                    return;
                }
                if(searchByVal == 'docId') {
                    updateDocId(text);
                } else {
                    if(!isNaN(text)) {
                        updateProductId(text);
                    }
                }
            }
        });
    }
    const leftCountryCode = () =>{
        return (
            <div className={'audit-country-code'}>+91</div>
        )
    }
    let inputGroupProps = {
        rightSection:(() => {return(navigator.clipboard?.readText && !isSamsungBrowser ? <div 
            onClick={(e) => {
                if (pasteRef?.current) {
                  pasteRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  pasteRef.current.focus(); 
                }
                pasteFromClipboard();
              }} 
            className = {'doc-paste-field'}>Paste</div> : null)}),
        rightIconClass : (((searchByVal == 'docId' && docId) || ((searchByVal == 'productId') && productId)) ? 'icon-HDRcross' : ''),
        onKeyDown : (e =>  {docProdKeyDown(e)}),
        onRightIconClick:()=>{
            if(searchByVal == 'docId') {
                updateDocId('');
                updateDocIdError('');
            } else {
                updateProductId('');
                updateProductIdError('')
            }
        }
    }
    
    let rightIconArray = [{
        isMoreMenu: true,
        options: [{label: "Log Out",
                    onClick: () => {
                        logOut({
                            token: props.session.token,
                            cb: (data) => {
                                if(data.data.isSuccess){
                                    props.setLoggedUser(null)
                                    history.push("/login");
                                } else {
                                    console.log('unable to logout');
                                }
                            }
                        });
                    }
                }]
    }];
    const showToastMsg = (msg) =>{
        props.showToastMessage({
            showToastMessage: true,
            message: msg,
            duration: 5000
        });
    }
    const Validations = (fromApiHit) =>{
        if(searchByVal == 'citycircle'){
            if(selectedCity == 'Select City'){
                updatecityError(true);
                showToastMsg('Please Select City');
                return true;
            }
        }
        else if(searchByVal == 'docId'){
            if(docId == ''){
                updateDocIdError('Please Enter Valid Doc ID');
                showToastMsg('Please Enter Valid Doc ID');
                return true;
            }
            if(fromApiHit){
                updateDocIdError('Doc ID Not Found');
                showToastMsg('Doc ID Not Found');
                return true;
            }
        }
        else if(searchByVal == 'productId'){
            if(productId == ''){
                updateProductIdError('Please Enter Valid Product ID');
                showToastMsg('Please Enter Valid Product ID');
                return true;
            }
            if(fromApiHit){
                updateProductIdError('Product ID Not Found');
                showToastMsg('Product ID Not Found');
                return true;
            }
        }
        else if(searchByVal == 'employee'){
            if(employeeTab == 'employeeid'){
                if(empId == ''){
                    updateEmpInputError('Please Enter Valid Employee ID');
                    showToastMsg('Please Enter Valid Employee ID');
                    return true;
                }
                if(fromApiHit){
                    updateEmpInputError('Employee ID Not Found');
                    showToastMsg('Employee ID Not Found');
                    return true;
                }
            }else{
                if(empMobileNo == '' || ('' + empMobileNo).length != 10){
                    updateEmpInputError('Please Enter Valid Mobile Number');
                    showToastMsg('Please Enter Valid Mobile Number');
                    return true;
                }
                if(fromApiHit){
                    updateEmpInputError('Mobile Number Not Found');
                    showToastMsg('Mobile Number Not Found');
                    return true;
                }
            }
        }
        if(searchByVal != 'productId' && fromDate && toDate){
            if(fromDate > toDate) {
                updateDateError1('Please Select a Valid Date Range');
                updateDateError2('Please Select a Valid Date Range');
                showToastMsg('Please Select a Valid Date Range');
                return true;
            }
        }
        return false;
    }
    useEffect(() => {
		if(props.session.user.loginData && (!props.session.user.loggedUser || (props.session.user.loggedUser && props.session.user.loggedUser.userType != 'AUDITOR'))){
            updateIsCorrector(false);
			// updateLoggedIn(true);
            history.push('/login');
		} else {
            if (props.session.user.loggedUser?.subType == 'CORRECTOR') {
                updateIsCorrector(true);
            }
            if(!cityOptions.length) {
                getCityList({updateCityList,updateSelectedCity});
            }
        }
    },[props.session.user.loginData]);
    useEffect(()=>{
        let auditStatsData = {...auditStats}
        axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=getOverallAuditStats`).then((data) => {
            if(data.data){
                auditStatsData = data.data;
                updateAuditStats(auditStatsData);
            }
        });
    },[])


    const onStatEmpty = (obj) => {
        updateAuditStats(prev => ({
            ...prev,
            [obj]: 0 
          }));
    }

    const onSearch = () => {
      let isError = false;
      if (Validations()) {
        isError = true;
      }
      if (!isError) {
        updateSearchBtnLoader(true);
        let options = {
          searchBy: searchByVal,
          productId: productId,
          city: selectedCity,
          showResultBy: showResultVal,
          searchEmployeeBy: searchByVal == "employee" ? employeeTab : "",
          docId: docId,
          employeeId: empId,
          employeeMobile: empMobileNo,
          lastModifiedFrom: fromDate ? fromDate.toJSON() : "",
          lastModifiedTo: toDate ? toDate.toJSON() : "",
          loadedInIframe: window.top != window.self ? true : undefined,
        };
        let queryStr = queryString.stringify(options);
        options.cb = (data) => {
          updateSearchBtnLoader(false);
          if (!data.data.status) {
            let status = Validations(true);
          } else {
            if (searchByVal == "productId") {
              if (data.data.status) {
                let url =
                  rewriteUrlForLocal(data.data.url) +
                  "&useAuditApi=true&searchBy=productId";
                if (window.top != window.self) {
                  url += "&loadedInIframe=true";
                }
                window.location.href = url;
              } else {
                let status = Validations(true);
              }
            } else if (searchByVal == "docId") {
              queryStr += "&useAuditApi=true&isAuditUrl=true";
              let url = `/vendor/manage-products-genio/${data.data.token}`;
              // if(data.data && data.data.isSpecialContract){
              queryStr +=
                "&isSpecialContract=true&actualToken=" + data.data.token;
              // }
              // history.push(url + "/products?" + queryStr);
              window.location.href = url + "/products?" + queryStr;
            } else {
              let arr = data.data.data && data.data.data.data;
              props.setAuditObject({
                contractArr: arr,
              });
              history.push("/audit-home/list?" + queryStr);
            }
          }
        };
        if (
          (showResultVal == "contracts" &&
            (searchByVal == "citycircle" || searchByVal == "employee")) ||
          searchByVal == "productId" ||
          searchByVal == "docId"
        ) {
          auditSearch(options);
        } else {
          queryStr += "&useAuditApi=true&isAuditUrl=true";
          history.push("/products?" + queryStr);
        }
      }
    };

    return (<>{ !params.listing ? <>
                <SliderHeader
                        heading={`B2B Catalogue ${isCorrector ? 'Correction' : 'Audit'} Module`}
                        rightIcons={rightIconArray}
                        variant='secondary'
                        className = {(isScrolled ? 'audit-header-unset' : '')}
                        raised = {isScrolled}
                    />
                    <div className = {'audit-home'}>
                        <div className = {'paddingLR15 top-section'}>
                            <div className = {'logged-in-header'}>
                                {`${isCorrector ? 'Correct' : 'Audit'} Products`}
                            </div>
                            <div className = {'logged-in-text'}>
                                {`You can click on Start ${isCorrector ? 'Correcting' : 'auditing'} Now to ${isCorrector ? 'correct' : 'audit'} products.`}
                            </div>
                            <AuditButton 
                                auditStats={auditStats}
                                onStatEmpty={obj => onStatEmpty(obj)}
                                isCorrector={isCorrector}
                            />
                        </div>
                        <AuditStats
                            auditStats={auditStats}
                            isCorrector={isCorrector}
                        />
                            
                            <div className = {'search-section paddingLR15'}>
                                <div className = {'logged-in-header'}>
                                    {'Search Product'}
                                </div>
                                <div className = {'search-by-section'}>
                                    <div className = {'header'}>{'Search By'}</div>
                                    <div className = {'selection'}>
                                        {
                                            searchByArr.map((item) => {
                                                let width = 100 / searchByArr.length;
                                                return (<span style = {{width: width + '%'}} className = {`selection-tab ${searchByVal == item.key ? 'selected' : ''}`} 
                                                    onClick = {() => {
                                                        updateSearchByVal(item.key);
                                                        resetError();
                                                    }}>
                                                    {item.display}
                                                </span>);
                                            })
                                        }
                                    </div>
                                </div>
                                {
                                    searchByVal == 'employee' && (<div className = {'search-by-section'}>
                                    <div className = {'header'}>{'Search Employee By'}</div>
                                    <div className = {'selection'}>
                                        {
                                            employeeTabList.map((item) => {
                                                let width = 100 / employeeTabList.length;
                                                return (<span style = {{width: width + '%'}} className = {`selection-tab ${employeeTab == item.key ? 'selected' : ''}`} 
                                                    onClick = {() => {
                                                        updateEmpInputError('');
                                                        updateEmployeeTab(item.key);
                                                        updateEmpId('');
                                                        updateEmpMobileNo('');
                                                    }}>
                                                    {item.display}
                                                </span>);
                                            })
                                        }
                                    </div>
                                </div>)
                                }
                                <div className = {'mid-section'}>
                                        {
                                            searchByVal == 'citycircle' && (<div className = {'section'}>
                                                 <InputWithMovingLabel
                                                    ref={inputRef}
                                                    label={'City'}
                                                    input={{
                                                        as:'select',
                                                        selected:selectedCity,
                                                        onChange:(e) => {
                                                            updatecityError(false);
                                                            updateSelectedCity(e.target.value);
                                                            inputRef && inputRef.current && inputRef.current.blur();
                                                        },
                                                        children:cityOptions,
                                                        className:'city-dropdown-list',
                                                    }}
                                                    holderClass={selectedCity == 'Select City' ? 'select-city' : ''}
                                                    errorMessage={cityError ? 'Please Select City' : ''}
                                                /> 
                                                {/* <Form.Group>
                                                    <Form.Label variant = {(cityError) ? 'invalid' : ''}>City</Form.Label>
                                                <Dropdown 
                                                    optionList={cityOptions}
                                                    className={cityError ? 'city-dropdown' : ''}
                                                    onChange={(key, val) => {
                                                        updatecityError(false);
                                                        updateSelectedCity(key.key);
                                                    }} 
                                                    isMobile={props.deviceData.isMobile}
                                                    value={selectedCity}
                                                    dropdownClass={'city-dropdown-list'}
                                                />	  
                                                {(cityError) && <Form.FeedBack className='error-subheader-text' variant={"invalid"}>Please Select City</Form.FeedBack>}      
                                                </Form.Group> */}
                                            </div>)
                                        }
                                        {
                                            (searchByVal == 'docId' || searchByVal == 'productId') && (<div className = {'section'}>
                                                <InputWithMovingLabel
                                                        label={searchByVal == 'docId' ? 'Enter Doc ID': 'Enter Product ID'}
                                                        ref = {pasteRef}
                                                        holderClass={''}
                                                        input={docIdInput}
                                                        key={searchByVal == 'docId' ? 'docID' : 'productId'}
                                                        inputGroupProps = {inputGroupProps}
                                                        errorMessage = {searchByVal == 'docId' ? docIdError: productIdError}
                                                />
                                            </div>)
                                        }
                                        {
                                            (searchByVal == 'employee') && (<div className = {'section'}>
                                                <InputWithMovingLabel
                                                        label={employeeTab == 'employeeid' ? 'Enter Employee ID': 'Enter Mobile Number'}
                                                        holderClass={''}
                                                        input={empIdInput}
                                                        className = {employeeTab == 'employeeid' ? '' : 'employee-mobile'}
                                                        prepend = {employeeTab == 'employeeid' ? '' : leftCountryCode}
                                                        key={employeeTab}
                                                        errorMessage = {empInputError}
                                                />
                                            </div>)
                                        }
                                        {/* { searchByVal != 'productId' &&  <div className = {'date-section'}>
                                            <div className = {'date-field'} onClick = {() => {
                                                    updateDateError1('');
                                                }}>
                                                <FormDate dateformat='dd/mm/yyyy' label = {'Last Modified From'} placeholder = {'DD/MM/YYYY'} isMobile={true} startDate={fromDate} onBlur={(event, date, obj, isValid) => {
                                                     const err = !isValid ? 'Invalid Date' : '';
                                                     updateDateError1(err);
                                                     if(isValid){
                                                        if(obj) {
                                                            obj.setHours(0,0,0,0);
                                                            updateFromDate(obj);
                                                        } else {
                                                            updateFromDate('');
                                                        }
                                                     }
                                                }} iconClass='icon-Calendar'
                                                onDateChange={(event, obj, date) => {
                                                    if(date) {
                                                        let temp = date.split('/');
                                                        let dateObj = new Date();
                                                        dateObj.setFullYear(Number(temp[2]));
                                                        dateObj.setMonth(Number(temp[1]) - 1);
                                                        dateObj.setDate(Number(temp[0]));
                                                        dateObj.setHours(0,0,0,0);
                                                        if(dateObj != "Invalid Date") {
                                                            updateFromDate(dateObj);
                                                        }
                                                    }
                                                }}
                                                errorMessage={dateError1}/>
                                            </div>
                                            <div className = {'date-field'} onClick = {() => {
                                                    updateDateError2('');
                                                }}>
                                                <FormDate dateformat='dd/mm/yyyy' label = {'Last Modified To'} placeholder = {'DD/MM/YYYY'} isMobile={true} startDate={toDate} onBlur={(event, date, obj, isValid) => {
                                                    const err = !isValid ? 'Invalid Date' : '';
                                                    updateDateError2(err);
                                                    if(isValid){
                                                        if(obj) {
                                                            obj.setHours(0,0,0,0);
                                                            updateToDate(obj);
                                                        } else {
                                                            updateToDate('');
                                                        }
                                                    }
                                                }} iconClass='icon-Calendar'
                                                onDateChange={(event, obj, date) => {
                                                    if(date) {
                                                        let temp = date.split('/');
                                                        let dateObj = new Date();
                                                        dateObj.setFullYear(Number(temp[2]));
                                                        dateObj.setMonth(Number(temp[1]) - 1);
                                                        dateObj.setDate(Number(temp[0]));
                                                        dateObj.setHours(0,0,0,0);
                                                        if(dateObj != "Invalid Date") {
                                                            updateToDate(dateObj);
                                                        }
                                                    }
                                                }}
                                                errorMessage={dateError2}/>
                                            </div>
                                        </div>} */}
                                </div>
                                {(searchByVal != 'productId' && searchByVal != 'docId') && <div className = {'show-result-by-section'}>
                                    <div className = {'header'}>{'Show Results By'}</div>
                                    <div className = {'selection'}>
                                        {
                                            searchTypeArr.map((item) => {
                                                let width = 100 / searchTypeArr.length;
                                                return (<span style = {{width: width + '%'}} className = {`selection-tab ${showResultVal == item.key ? 'selected' : ''}`} 
                                                    onClick = {() => {
                                                        updateShowResultVal(item.key);
                                                    }}>
                                                    {item.display}
                                                </span>);
                                            })
                                        }
                                    </div>
                                </div>}
                                <Button 
                                className = {'search-btn'}
                                showLoader = {searchBtnLoader}
                                size="lg"
                                clickHandler = {onSearch}
                                >Search</Button>
                            </div>
                            {
                                !isCorrector ? <div className={'audit-stats paddingLR15 top-section'}>
                                    <div className={'audit-header reports'}>
                                    <div className = {'logged-in-header'}>
                                            Reports
                                    </div>
                                    </div>
                                    <div>
                                        <Button
                                            className={'search-btn'}
                                            variant={'default'}
                                            clickHandler = {() => {
                                                getData({
                                                    cb : (data) => {
                                                        if(data && data.status){
                                                            updateCurrentStep(1);
                                                            updateVal(Math.floor(data.progressCnt));
                                                            updateSlider('audit-report');
                                                        }else{
                                                            resetAuditReportSlider();
                                                            updateSlider('audit-report');
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            Audit Report
                                        </Button>
                                        {/* <Button
                                            className={'search-btn'}
                                            variant={'default'}
                                            clickHandler = {() => {
                                                downloadReports({
                                                    type: 'skipReport'
                                                });
                                            }}
                                        >
                                            Skipped Furlough Contract Report
                                        </Button> */}
                                    </div>
                                    <div>
                                        <Button
                                            className={'search-btn'}
                                            variant={'default'}
                                            clickHandler={() => {
                                                setExportDataSlider(true);
                                            }}
                                        >
                                            Export Queue Data
                                        </Button>
                                    </div>
                                </div> : null
                            }
                            {/* <div className={'audit-stats paddingLR15 top-section'}>
                                <div className={'audit-header'}>
                                   <div className = {'logged-in-header'}>
                                        Tools
                                   </div>
                                </div>
                                <div>
                                    <Button
                                        className={'search-btn'}
                                        variant={'default'}
                                        onClick={() => {
                                            updateFurDocIdError('');
                                            updateFurDocId('');
                                             setTimeout(() => {
                                                updateSlider('furlough');
                                            }, 300);
                                        }}
                                    >
                                        Convert Contract to Furlough
                                    </Button>
                                </div>
                            </div> */}
                            {showSlider && <SliderWrapper
                                header={sliderObject.header}
                                slider={sliderObject.slider}
                                onHidden={sliderObject.onHidden}
                                footer={sliderObject.footer}
                            >
                                {sliderObject.html}
                            </SliderWrapper>}                            
                            {showModal &&
                                <Modal
                                    settings={{
                                        modalId: 'actionModal',
                                        variant: 'webstore',
                                        modalInsideSlider: true
                                    }}
                                    onHidden={() => {
                                        toggleModal(false);
                                        updateFurModalData({});
                                    }}
                                >
                                    <Modal.CloseIcon />
                                    <div className={'furmod-section'}>
                                        <div className={'header'}>
                                            {'Are you sure you want to convert the below Contract to Furlough?'}
                                        </div>
                                        <div className={'header-bold'}>
                                            {furModalData.companyName}
                                        </div>
                                        <div className={'sub-text'}>
                                            {`${furModalData.area} - ${furModalData.city}`}
                                        </div>
                                        <div className={'sub-text'} style={{ marginBottom: '1rem' }}>
                                            {furDocId}
                                        </div>
                                        <Button
                                            size="lg"
                                            showLoader={confirmBtnLoader}
                                            clickHandler={() => {
                                                furloughApi({
                                                    updateFurDocIdError,
                                                    updateFurBtnLoader,
                                                    furDocId,
                                                    toggleModal,
                                                    furBtnLoader,
                                                    updateSlider,
                                                    confirmBtnLoader,
                                                    showToastMsg,
                                                    updateFurModalData,
                                                    updateConfirmBtnLoader
                                                });
                                            }}
                                            block
                                        >
                                            Confirm
                                        </Button>
                                    </div>
                                </Modal>}
                                {exportDataSlider && <SliderWrapper
                                    header={{
                                        heading: 'Export Queue Data',
                                        leftIcons: [{
                                            className: 'icon-hdrBackNew',
                                            onClick: (e) => { exportDataSliderHandler() }
                                        }],
                                    }}
                                    slider={{
                                        className: 'slider-export-queue-data'
                                    }}
                                    footer={{
                                        btnProps: [{
                                            children: auditExpDropDown ? 'Continue' : 'Send Email',
                                            clickHandler: () => {
                                                exportQueueDataHandler()
                                            },
                                            size: "lg",
                                            className: 'edit-batch-footer-btn'
                                        }]
                                    }}
                                >
                                    <div className={`audit-download-reports`}>
                                        <div className={`progress-status`}>
                                            <div className={`progress-circle ${auditExpCurrentStep > 0 ? 'completed' : ''} ${auditExpCurrentStep == 0 ? 'current' : ''}`}>
                                                {<i className={`${auditExpCurrentStep ? 'icon-Checkmark' :'icon-Checkmark spc' }`} ></i>}
                                            </div>
                                            <div className={`progress-circle-connect ${auditExpCurrentStep > 0 ? 'filled' : ''}`}></div>
                                            <div className={`progress-circle ${auditExpCurrentStep > 0 ? 'completed' : ''} ${auditExpCurrentStep == 0 ? 'current' : ''}`}>
                                                {auditExpCurrentStep > 0 ? <i className='icon-Checkmark'></i> : null}
                                            </div>
                                        </div>
                                    </div>
                                    {auditExpDropDown && <div className='export-drop-down'>
                                        <label className='export-drop-down-label'> Select Queue Type</label>
                                        <Dropdown
                                            className={'export-drop-down-dropdown-div'}
                                            optionList={auditExpArr}
                                            style={{ maxWidth: '320px' }}
                                            onChange={(e, value) => {
                                                setAuditExpValue(e)
                                            }}
                                            placeholder='Select Queue Type'
                                            value={auditExpValue.key}
                                        ></Dropdown>
                                    </div>}
                                    {auditExpEmailToggle && <div className='audit-exp-email'>
                                        <label className='export-drop-down-label'>Enter Email Address</label>
                                        <InputWithMovingLabel
                                            label={''}
                                            errorMessage={auditExpEmailErr ? `Please enter valid Justdial email address ${notValidEmail ? '-' : ''} ${notValidEmail}` : ''}
                                            holderClass={'audit-exp-email-container'}
                                            as={'textarea'}
                                            input={{
                                                value: auditExpEmail,
                                                onChange: e => exportEmailHandler(e.target.value)
                                            }}
                                        />
                                    </div>}
                                </SliderWrapper>}
            </div>
            </> : <ContractSearchPage></ContractSearchPage>}
            </>);
};

const mapStateToProps = state => {
	return {
		session: state.session,
		auditData: state.products.auditData,
		deviceData: state.deviceData
	};
};

export default connect(mapStateToProps,{setLoggedUser,setAuditObject,showToastMessage})(HomePage);
